import {t} from '@eitje/bridge'
import {useForm} from '@eitje/form'

export const useFormSubmitButtonProps = () => {
	const {form, submit} = useForm()

	const {errs} = form?.validateInner?.() || {}
	const isMissingRequiredFields = errs ? Object.values(errs).some(e => e === t('form.required')) : false

	const onSubmit = async () => submit?.()

	return {onSubmit, isMissingRequiredFields}
}
